<template>
  <div id="app" style="height: 100%">
    <router-view />
  </div>
</template>
<script>
export default {
  computed: {
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  },
  mounted() {
    let search = location.search
    let currentIndex = search.indexOf('=') + 1
    let city = location.search.substring(currentIndex, search.length)
    if (this._isMobile) {
      this.$router.push({ path: '/hb2026/mobile', query: { city: decodeURIComponent(city) } })
    } else {
      this.$router.push({ path: '/hb2026', query: { city: decodeURIComponent(city) } })
    }
  }
}
</script>
<style lang="scss"></style>
